import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { QcsToggleButton } from '../common/basic/QcsToggleButton';
import { useTranslation } from 'react-i18next';
import { FC, useState } from 'react';
import { useAppDispatch } from '../../store';
import { QcsButton } from '../common/basic/QcsButton';
import { GridFilterItemContainer } from '../common/grid/GridFilterStyles';
import { invitationListActions, InvitationListFilter } from '../../store/entities/invitationList';
import { StyledQcsPopover } from '../common/grid/GridFilterItem';
import { GridFilterDateFromTo } from '../common/grid/GridFilterDateFromTo';
import { QcsCheckbox } from '../common/basic/QcsCheckbox';
import { QcsFormControlLabel } from '../common/basic/QcsFormControlLabel';
import { DateFromTo } from '../../models/common';

interface Props {
  query: InvitationListFilter;
}

export const InvitationFilterValidTo: FC<Props> = ({ query }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const dispatch = useAppDispatch();

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleChangeDateFromTo = (value?: DateFromTo) => {
    dispatch(invitationListActions.updateFilter({ validTo: value }));
  };

  const handleChangeValidToEmpty = () => {
    dispatch(
      invitationListActions.updateFilter({
        validToEmpty: !query.validToEmpty,
      }),
    );
  };

  const handleClear = () => {
    dispatch(
      invitationListActions.updateFilter({
        validTo: undefined,
        validToEmpty: undefined,
      }),
    );
  };

  const selected = query.validTo !== undefined || !!query.validToEmpty;

  return (
    <>
      <QcsToggleButton value="" selected={selected} onChange={handleOpenMenu}>
        {t('invitation.validTo')}
        <ArrowDropDownIcon />
      </QcsToggleButton>
      <StyledQcsPopover
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleCloseMenu}
      >
        <GridFilterItemContainer>
          <GridFilterDateFromTo value={query.validTo} onChange={handleChangeDateFromTo} />
          <QcsFormControlLabel
            control={
              <QcsCheckbox
                checked={!!query.validToEmpty}
                onChange={handleChangeValidToEmpty}
              />
            }
            label={t('invitation.validToEmpty')}
          />
        </GridFilterItemContainer>
        <GridFilterItemContainer>
          <QcsButton disabled={!selected} onClick={handleClear}>
            {t('common.clearFilter')}
          </QcsButton>
        </GridFilterItemContainer>
      </StyledQcsPopover>
    </>
  );
};
